import React, { useMemo } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Numeric } from '@swyftx/aviary/atoms/Typography';
import { NumericProps } from '@swyftx/aviary/atoms/Typography/Numeric/Numeric.styles';

import { cn } from '@shared/utils/lib/ui';

type Props = {
  stepIncrement: number;
  maxIncrement: number;
  size?: NumericProps['size'];
};

const MarginAccountHealthBarMarks: React.FC<Props> = ({ stepIncrement, maxIncrement, size = 'small' }) => {
  const marks = useMemo(
    () => new Array(Math.floor((maxIncrement + stepIncrement) / stepIncrement) * 5).fill(''),
    [stepIncrement, maxIncrement],
  );

  const getStepLabel = (index: number) => {
    const val = index * stepIncrement;
    return `${val}${val === maxIncrement ? '+' : ''}`;
  };

  return (
    <>
      {marks.map((_, index) => (
        <FlexLayout
          alignItems='center'
          justifyContent='center'
          key={index}
          className={cn(
            index !== 0 && index % 5 === 0 ? 'h-[44px]' : 'h-[32px]',
            'relative w-2 bg-color-background-surface-secondary md:w-1',
          )}
        >
          {index !== 0 && index % 5 === 0 && (
            <Numeric
              color='secondary'
              size={size}
              className='absolute -left-1/2 bottom-44 -translate-x-1/2 text-center'
              key={index}
            >
              {getStepLabel(index / 5)}
            </Numeric>
          )}
        </FlexLayout>
      ))}
    </>
  );
};

export { MarginAccountHealthBarMarks };
